import { useQuery } from "react-query";
import { getJSON } from "../../../../http";
import { dimensionsKey, dimensionsUrl } from "./dimensions.constants";
import { DimensionsResponse } from "./dimensions.types";

export interface IDimensionsQuery {
  isDimensionsLoading: boolean;
  dimensionsError: unknown,
  dimensions?: DimensionsResponse;
}

export function useDimensionssQuery<IDimensionsQuery>(dataSourceId?: number) {
  const queryKey = `${dimensionsKey}/${dataSourceId}`;
  const queryUrl = `${dimensionsUrl}/${dataSourceId}`;
  const { isLoading, error, data } = useQuery(queryKey, () =>
    dataSourceId === undefined ? undefined : getJSON<DimensionsResponse>(queryUrl)
  );
  return { isDimensionsLoading: isLoading, dimensionsError: error, dimensions: data };
}
